export const config = {
    // Built-in Vite environment variables
    MODE: import.meta.env.MODE,
    BASE_URL: import.meta.env.BASE_URL,
    PROD: import.meta.env.PROD,
    DEV: import.meta.env.DEV,
    SSR: import.meta.env.SSR,

    // Custom application environment variables
    VITE_APP_VERSION: import.meta.env.VITE_APP_VERSION,
    VITE_BACKEND_URL: import.meta.env.VITE_BACKEND_URL,
    VITE_SENTRY_DEBUG: import.meta.env.VITE_SENTRY_DEBUG,
    VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    VITE_POST_HOG_KEY: import.meta.env.VITE_POST_HOG_KEY
} as const;
